import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { Target, Heart, Clock, Users, Truck, Shield, MessageCircle, ArrowRight } from 'lucide-react';

function About() {
  const { t } = useLanguage();

  const values = [
    { icon: Target, title: t('ourMission'), desc: 'Oferecer produtos de alta qualidade a preços competitivos, garantindo a satisfação de cada cliente.' },
    { icon: Heart, title: t('ourValues'), desc: 'Honestidade, qualidade, compromisso e atendimento personalizado em cada interação.' },
    { icon: Clock, title: t('ourHistory'), desc: 'Desde o início, crescemos junto com nossos clientes, construindo uma reputação de excelência.' },
    { icon: Users, title: 'Nossa Equipe', desc: 'Profissionais apaixonados, prontos para assessorá-lo e ajudá-lo a encontrar o que precisa.' },
  ];

  const features = [
    { icon: Truck, title: t('fastDelivery'), desc: t('fastDeliveryDesc') },
    { icon: Shield, title: t('qualityGuarantee'), desc: t('qualityGuaranteeDesc') },
    { icon: MessageCircle, title: t('personalizedService'), desc: t('personalizedServiceDesc') },
  ];

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
        padding: '100px 20px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '20px',
            backgroundColor: 'rgba(59, 130, 246, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 28px',
          }}>
            <span style={{ fontSize: '36px' }}>🛍️</span>
          </div>
          <h1 style={{
            fontSize: '44px',
            fontWeight: '700',
            color: 'white',
            marginBottom: '16px',
            letterSpacing: '-0.5px',
          }}>
            ASMAR SHOP
          </h1>
          <p style={{
            fontSize: '20px',
            color: '#94a3b8',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6',
          }}>
            Sua loja de confiança em produtos de qualidade e atendimento personalizado
          </p>
        </div>
      </div>

      {/* Values Section */}
      <div style={{
        maxWidth: '1200px',
        margin: '-60px auto 0',
        padding: '0 20px 60px',
        position: 'relative',
        zIndex: 10,
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '24px',
          padding: '48px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '32px',
          }}>
            {values.map((value, index) => (
              <div
                key={index}
                style={{
                  textAlign: 'center',
                  padding: '24px',
                  borderRadius: '20px',
                  backgroundColor: '#f8fafc',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                }}>
                  <value.icon size={28} color="white" />
                </div>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '700',
                  color: '#1f2937',
                  marginBottom: '12px',
                }}>
                  {value.title}
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  lineHeight: '1.6',
                  margin: 0,
                }}>
                  {value.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div style={{
        backgroundColor: 'white',
        padding: '80px 20px',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
        }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#1f2937',
              marginBottom: '12px',
            }}>
              {t('whyChooseUs')}
            </h2>
            <p style={{
              fontSize: '18px',
              color: '#6b7280',
            }}>
              {t('bestOption')}
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px',
          }}>
            {features.map((feature, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px',
                  padding: '28px',
                  borderRadius: '20px',
                  backgroundColor: '#f8fafc',
                  border: '2px solid transparent',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#3b82f6';
                  e.currentTarget.style.backgroundColor = '#f0f9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.backgroundColor = '#f8fafc';
                }}
              >
                <div style={{
                  width: '52px',
                  height: '52px',
                  borderRadius: '14px',
                  backgroundColor: '#dbeafe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <feature.icon size={24} color="#3b82f6" />
                </div>
                <div>
                  <h3 style={{
                    fontSize: '17px',
                    fontWeight: '600',
                    color: '#1f2937',
                    marginBottom: '8px',
                  }}>
                    {feature.title}
                  </h3>
                  <p style={{
                    fontSize: '14px',
                    color: '#6b7280',
                    lineHeight: '1.6',
                    margin: 0,
                  }}>
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px 80px',
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
          borderRadius: '24px',
          padding: '60px 40px',
          textAlign: 'center',
        }}>
          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: 'white',
            marginBottom: '16px',
          }}>
            Pronto para conhecer nossos produtos?
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#94a3b8',
            marginBottom: '32px',
            maxWidth: '500px',
            margin: '0 auto 32px',
          }}>
            Explore nossa coleção completa e encontre exatamente o que você precisa.
          </p>
          <div style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <Link
              to="/products/"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '16px 32px',
                borderRadius: '14px',
                backgroundColor: '#3b82f6',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '600',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#2563eb';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#3b82f6';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {t('products')}
              <ArrowRight size={20} />
            </Link>
            <Link
              to="/contact/"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '16px 32px',
                borderRadius: '14px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '600',
                border: '2px solid rgba(255,255,255,0.2)',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
              }}
            >
              <MessageCircle size={20} />
              {t('contact')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
